import {
  v4 as uuid
} from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [{
    _id: uuid(),
    title: "Coffee Can Investing",
    author: "Saurabh Mukherjea",
    price: "399",
    rating: 4,
    image: "https://m.media-amazon.com/images/I/81wr8n5+vhL._AC_UY218_.jpg",
    categoryName: "Literature & Fiction",
    wishlist: false,
    badge: "best seller"
  },
  {
    _id: uuid(),
    title: "Harry Potter and the Order of the Phoenix",
    author: "J.K. Rowling ",
    price: "550",
    rating: 4.5,
    image: "https://m.media-amazon.com/images/I/91t5-Juqt9L._AC_UY218_.jpg",
    categoryName: "Literature & Fiction",
    wishlist: false,
    badge: "best seller"
  },
  {
    _id: uuid(),
    title: "Harry Potter and the Deathly Hallows",
    author: "J.K. Rowling ",
    price: "650",
    rating: 4.5,
    image: "https://m.media-amazon.com/images/I/81NEMbJJg8L.SR160,240_BG243,243,243.jpg",
    categoryName: "Literature & Fiction",
    wishlist: false,
    badge: "out of stock"
  },
  {
    _id: uuid(),
    title: "The Cruise to Forever",
    author: "Susan Remini Walden ",
    price: "4999",
    rating: 3.5,
    image: "https://m.media-amazon.com/images/I/71PmGm8q9AL._AC_UY218_.jpg",
    categoryName: "Romance",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "One Arranged Murder",
    author: "Chetan Bhagat",
    price: "199",
    rating: 3,
    image: "https://m.media-amazon.com/images/I/71fgd+WAkHL._AC_UY218_.jpg",
    categoryName: "Romance",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "You Only Live Once",
    author: "Stuti Changle ",
    price: "240",
    rating: 3,
    image: "https://m.media-amazon.com/images/I/71dNsRuYL7L._AC_UY218_.jpg",
    categoryName: "Romance",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "Zero to One",
    author: "Peter Thiel",
    price: "450",
    rating: 3.5,
    image: "https://images-eu.ssl-images-amazon.com/images/I/51z7mZZKRgL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    categoryName: "Business & Economics",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "My Life in Full",
    author: "Indra K. Nooyi",
    price: "448",
    rating: 2,
    image: "https://images-na.ssl-images-amazon.com/images/I/41Vyss0-f1L._SX308_BO1,204,203,200_.jpg",
    categoryName: "Business & Economics",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "Business School",
    author: "Robert T. Kiyosaki",
    price: "110",
    rating: 4,
    image: "https://m.media-amazon.com/images/I/51-D65ye4WL._AC_UY218_.jpg",
    categoryName: "Business & Economics",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "Rich Dad Poor Dad",
    author: "Robert T. Kiyosaki",
    price: "220",
    rating: 4,
    image: "https://m.media-amazon.com/images/I/81bsw6fnUiL._AC_UY218_.jpg",
    categoryName: "Business & Economics",
    wishlist: false,
    badge: "best seller"
  },
  {
    _id: uuid(),
    title: "Death; An Inside Story",
    author: "Sadhguru",
    price: "700",
    rating: 2,
    image: "https://images-na.ssl-images-amazon.com/images/I/41FvL+u1ENL._SY344_BO1,204,203,200_.jpg",
    categoryName: "Spirituality",
    wishlist: false,
    badge: "none"
  },

  {
    _id: uuid(),
    title: "Karma",
    author: "Sadhguru",
    price: "460",
    rating: 1,
    image: "https://images-eu.ssl-images-amazon.com/images/I/51UnDt5zNbS._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    categoryName: "Spirituality",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "Think Like a Monk",
    author: "Jay Shetty",
    price: "680",
    rating: 3,
    image: "https://images-na.ssl-images-amazon.com/images/I/41gVhoPaE5L._SX323_BO1,204,203,200_.jpg",
    categoryName: "Spirituality",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "When I grow up I want to be",
    author: "Tweak Books ",
    price: "100",
    rating: 2,
    image: "https://images-eu.ssl-images-amazon.com/images/I/51grRPUs3eL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    categoryName: "Kindle",
    wishlist: false,
    badge: "none"
  },
  {
    _id: uuid(),
    title: "Skin Sense",
    author: "Kiran Sethi",
    price: "130",
    rating: 2,
    image: "https://images-eu.ssl-images-amazon.com/images/I/51grRPUs3eL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    categoryName: "Kindle",
    wishlist: false,
    badge: "best seller"
  }
];
